class Field {
  // eslint-disable-next-line no-undef
  [key: string]: any;

  constructor(fields: any) {
      Object.assign(this, fields);
  }
}

export function isFormField(obj: any) {
    return obj instanceof Field;
}

export default function createFormField(field: any) {
    if (isFormField(field)) {
        return field;
    }
    return new Field(field);
}
